import { validator } from "@/utils/validator";

export const masterDataMainIndustrySchema = validator.object().shape({
  mainIndustry: validator.string().trim().emptyToNull().label("主たる業種").required(),
});
